import React from "react";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import PublicLayout from "@/components/layout/PublicLayout";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import ProjectsPage from "@/pages/ProjectsPage";
import ServicesPage from "@/pages/ServicesPage";
import ContactPage from "@/pages/ContactPage";
import TermsPage from "@/pages/TermsPage";
import PrivacyPage from "@/pages/PrivacyPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboardPage from "@/pages/AdminDashboardPage";
import AdminMediaPage from "@/pages/AdminMediaPage";
import AdminBrochuresPage from "@/pages/AdminBrochuresPage";
import AdminSettingsPage from "@/pages/AdminSettingsPage";
import AdminDirectorsPage from "@/pages/AdminDirectorsPage";
import AdminProtectedRoute from "@/components/admin/AdminProtectedRoute";
import NotFoundPage from "@/pages/NotFoundPage";
import { SiteContentProvider } from "@/lib/SiteContent";
import CookieConsent from "@/components/common/CookieConsent";

function App() {
  return (
    <HelmetProvider>
      <SiteContentProvider>
        <BrowserRouter>
        <Routes>
          {/* Public routes wrapped in layout */}
          <Route
            path="/"
            element={
              <PublicLayout>
                <HomePage />
              </PublicLayout>
            }
          />
          <Route
            path="/about"
            element={
              <PublicLayout>
                <AboutPage />
              </PublicLayout>
            }
          />
          <Route
            path="/projects"
            element={
              <PublicLayout>
                <ProjectsPage />
              </PublicLayout>
            }
          />
          <Route
            path="/services"
            element={
              <PublicLayout>
                <ServicesPage />
              </PublicLayout>
            }
          />
          <Route
            path="/contact"
            element={
              <PublicLayout>
                <ContactPage />
              </PublicLayout>
            }
          />
          <Route
            path="/terms"
            element={
              <PublicLayout>
                <TermsPage />
              </PublicLayout>
            }
          />
          <Route
            path="/privacy"
            element={
              <PublicLayout>
                <PrivacyPage />
              </PublicLayout>
            }
          />

          {/* Admin routes (no public layout) */}
          <Route path="/admin" element={<AdminLoginPage />} />
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route
            path="/admin/dashboard"
            element={
              <AdminProtectedRoute>
                <AdminDashboardPage />
              </AdminProtectedRoute>
            }
          />
          <Route
            path="/admin/media"
            element={
              <AdminProtectedRoute>
                <AdminMediaPage />
              </AdminProtectedRoute>
            }
          />
          <Route
            path="/admin/brochures"
            element={
              <AdminProtectedRoute>
                <AdminBrochuresPage />
              </AdminProtectedRoute>
            }
          />
          <Route
            path="/admin/settings"
            element={
              <AdminProtectedRoute>
                <AdminSettingsPage />
              </AdminProtectedRoute>
            }
          />
          <Route
            path="/admin/directors"
            element={
              <AdminProtectedRoute>
                <AdminDirectorsPage />
              </AdminProtectedRoute>
            }
          />

          <Route
            path="*"
            element={
              <PublicLayout>
                <NotFoundPage />
              </PublicLayout>
            }
          />
        </Routes>
        <CookieConsent />
      </BrowserRouter>
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: "rgba(18,18,18,0.95)",
            backdropFilter: "blur(20px)",
            border: "1px solid rgba(212,175,55,0.32)",
            color: "#fff",
          },
        }}
      />
    </SiteContentProvider>
    </HelmetProvider>
  );
}

export default App;
